import { Link } from 'react-router-dom';
import type { NewsItem } from '@/mocks/news';

export default function NewsSection({ items }: { items: NewsItem[] }) {
  return (
    <section className="mx-auto max-w-[1440px] px-4 md:px-8 py-12 md:py-16">
      <div className="flex items-end justify-between mb-6 md:mb-8">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-black text-foreground-950">最新影视资讯</h2>
          <p className="mt-1 text-sm text-foreground-500 font-body">实时追踪影视动态、幕后花絮与影评解读</p>
        </div>
        <Link to="/news" className="hidden sm:flex items-center gap-1 text-sm text-primary-600 font-label font-medium cursor-pointer whitespace-nowrap">
          更多资讯
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="flex flex-col divide-y divide-background-200 border-t border-b border-background-200">
        {items.map((item) => (
          <Link
            key={item.id}
            to={`/news/${item.id}`}
            className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6 py-5 cursor-pointer group"
          >
            <div className="w-full sm:w-40 h-28 sm:h-24 flex-shrink-0 rounded-lg overflow-hidden bg-background-200">
              <img src={item.cover} alt={item.title} className="w-full h-full object-cover object-top" />
            </div>
            <div className="min-w-0 flex-1">
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 group-hover:text-primary-600 transition-colors truncate">
                {item.title}
              </h3>
              <p className="mt-1.5 text-sm text-foreground-500 font-body line-clamp-1">{item.summary}</p>
              <p className="mt-2 text-xs text-foreground-400 font-label">{item.date}</p>
            </div>
            <i className="ri-arrow-right-s-line text-foreground-400 text-xl hidden sm:block"></i>
          </Link>
        ))}
      </div>
    </section>
  );
}